import { useSelector } from 'react-redux';
import { Settings } from '../store/reducers/AccountSlice';

export function useStoreCountry(): string | undefined {
  const settings: Settings = useSelector((state: any) => state.settings.value);
  return settings?.country;
}

